import { Box, Image } from '@chakra-ui/react';
import React from 'react';
// import { Fidenza } from '../Icons/Fidenza';
import MapImage from '../../assets/images/map.png';
import Bicester from '../../assets/images/map/bicester.png';
import BicesterHover from '../../assets/images/map/bicester_hover.png';
import FidanzaHover from '../../assets/images/map/fidanza_hover.png';
import Fidanza from '../../assets/images/map/fidenza.png';
import Ingo from '../../assets/images/map/ingo.png';
import IngoHover from '../../assets/images/map/ingo_hover.png';
import Kildare from '../../assets/images/map/kildare.png';
import KildareHover from '../../assets/images/map/kildare_hover.png';
import LaRoca from '../../assets/images/map/laroca.png';
import LaRocaHover from '../../assets/images/map/laroca_hover.png';
import LasRozas from '../../assets/images/map/lasrozas.png';
import LasRozasHover from '../../assets/images/map/lasrozas_hover.png';
import LaVallee from '../../assets/images/map/lavallee.png';
import LaValleeHover from '../../assets/images/map/lavallee_hover.png';
import Maas from '../../assets/images/map/maas.png';
import MaasHover from '../../assets/images/map/maas_hover.png';
import Shanghai from '../../assets/images/map/shanghai.png';
import ShanghaiHover from '../../assets/images/map/shanghai_hover.png';
import SuzhouHover from '../../assets/images/map/suzhou_hover.png';
import Wertheim from '../../assets/images/map/wertheim.png';
import WertheimHover from '../../assets/images/map/wertheim_hover.png';
// import LanguageSwitcher from '../components/common/LanguageSwitcher';
// import SelectLanguage from '../SelectLanguage';
import { disptchCTAClickObject } from '../../Analytics';
import Logo from '../../assets/images/bicester_collection.png';
import Background from '../../assets/images/map_texture.png';
import MapVillageV2 from '../../components/common/MapVillageV2';
import { MapV2Props } from '../../interfaces/components';
import useWindowDimensions from '../../utils/hooks/useWindowDimensions';
import MapMobile from './MapMobile';

const MapV2 = ({ setActive, villageName }: MapV2Props) => {
  const { width } = useWindowDimensions();

  const goToLaRocaVillage = () => {
    disptchCTAClickObject(villageName, 'Button', 'VillageSelect', 'laroca', '');
    window.InitiateExperience();
    window.GotoScene('lr_exterior_0');

    setTimeout(() => {
      setActive('laroca');
    }, 500);
  };

  const goToLaValleeVillage = () => {
    window.InitiateExperience();
    window.GotoScene('lv_village_0');
    disptchCTAClickObject(villageName, 'Button', 'VillageSelect', 'lavallee', '');

    setTimeout(() => {
      setActive('lavallee');
    }, 500);
  };

  const goToBicesterVillage = () => {
    window.InitiateExperience();
    window.GotoScene('bv_village_0');

    setTimeout(() => {
      setActive('bicester');
    }, 500);
  };

  const goToFidenzaVillage = () => {
    window.InitiateExperience();
    window.GotoScene('fv_village_0');

    setTimeout(() => {
      setActive('fidenza');
    }, 500);
  };

  // useEffect(() => {
  //   window.onmousemove = function (e) {
  //     const difference = window.innerWidth - e.clientX;
  //     console.log('Difference', difference);
  //   };
  // }, []);

  return (
    <>
      {width < 770 ? (
        <MapMobile setActive={setActive} />
      ) : (
        <Box
          w="100%"
          h="100vh"
          overflowX="auto"
          overflowY="auto"
          // backgroundColor="rgba(80,80,40,0.2)"
          backgroundImage={Background}
          backgroundRepeat="no-repeat"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box h="auto" w={['1910px', '1910px', '770px', '1000px', '1500px']} position="relative">
            <Image src={MapImage} objectFit="contain" alt="map" />

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              position="absolute"
              left="0px"
              top="0px"
              w="100%"
              zIndex={1}
              pt={['5', '5', '5', '7', '10']}
              userSelect="none"
            >
              <Image
                src={Logo}
                w={['250px', '250px', '150px', '200px', '250px']}
                objectFit="contain"
                alt="bicester collection"
              />
            </Box>

            <MapVillageV2
              top={['220px', '220px', '60px', '100px', '170px']}
              left={['230px', '230px', '70px', '120px', '180px']}
              right={['auto']}
              bottom={['auto']}
              hoverTop={['100px', '100px', '40px', '50px', '80px']}
              hoverLeft={['100px', '100px', '40px', '60px', '90px']}
              hoverRight={['auto']}
              hoverBottom={['auto']}
              text="KILDARE VILLAGE"
              src={Kildare}
              hover={KildareHover}
            />
            <MapVillageV2
              top={['270px', '270px', '85px', '125px', '210px']}
              left={['550px', '550px', '205px', '295px', '440px']}
              right={['auto']}
              bottom={['auto']}
              hoverTop={['150px', '150px', '50px', '70px', '100px']}
              hoverLeft={['410px', '410px', '165px', '240px', '360px']}
              hoverRight={['auto']}
              hoverBottom={['auto']}
              text="BICESTER VILLAGE"
              src={Bicester}
              hover={BicesterHover}
              onClick={goToBicesterVillage}
            />
            <MapVillageV2
              top={['290px', '290px', '85px', '120px', '215px']}
              left={['955px', '955px', '420px', '520px', '785px']}
              right={['auto']}
              bottom={['auto']}
              hoverTop={['155px', '155px', '50px', '80px', '125px']}
              hoverLeft={['780px', '780px', '350px', '445px', '690px']}
              hoverRight={['auto']}
              hoverBottom={['auto']}
              text="MAASMECHELEN VILLAGE"
              src={Maas}
              hover={MaasHover}
              flexDir={['column', 'column', 'row', 'row']}
            />
            <MapVillageV2
              top={['430px', '430px', '135px', '185px', '305px']}
              left={['1075px', '1075px', '460px', '575px', '865px']}
              right={['auto']}
              bottom={['auto']}
              hoverTop={['355px', '355px', '115px', '165px', '240px']}
              hoverLeft={['980px', '980px', '390px', '510px', '760px']}
              hoverRight={['auto']}
              hoverBottom={['auto']}
              text="WERTHEIM VILLAGE"
              src={Wertheim}
              hover={WertheimHover}
              flexDir={['column', 'column', 'row', 'row']}
            />
            <MapVillageV2
              top={['510px', '510px', '185px', '245px', '390px']}
              left={['auto']}
              right={['470px', '470px', '190px', '160px', '310px']}
              bottom={['auto']}
              hoverTop={['335px', '335px', '140px', '175px', '275px']}
              hoverLeft={['auto']}
              hoverRight={['400px', '400px', '140px', '190px', '310px']}
              hoverBottom={['auto']}
              text="INGOLSTADT VILLAGE"
              src={Ingo}
              hover={IngoHover}
            />
            <MapVillageV2
              top={['390px', '390px', '130px', '190px', '285px']}
              left={['auto']}
              right={['140px', '140px', '90px', '85px', '150px']}
              bottom={['auto']}
              hoverTop={['250px', '250px', '100px', '140px', '200px']}
              hoverLeft={['auto']}
              hoverRight={['100px', '100px', '55px', '70px', '115px']}
              hoverBottom={['auto']}
              text="BICESTER VILLAGE SUZHOU"
              src={Shanghai}
              hover={SuzhouHover}
              flexDir="column"
            />
            <MapVillageV2
              top={['470px', '470px', '180px', '250px', '395px']}
              left={['auto']}
              right={['25px', '25px', '35px', '20px', '55px']}
              bottom={['auto']}
              hoverTop={['355px', '355px', '140px', '205px', '305px']}
              hoverLeft={['auto']}
              hoverRight={['0px', '0px', '10px', '15px', '30px']}
              hoverBottom={['auto']}
              text="BICESTER VILLAGE SHANGHAI"
              src={Shanghai}
              hover={ShanghaiHover}
              flexDir="column"
            />
            <MapVillageV2
              top={['540px', '540px', '190px', '255px', '410px']}
              left={['690px', '690px', '260px', '365px', '550px']}
              right={['auto']}
              bottom={['auto']}
              hoverTop={['400px', '400px', '160px', '220px', '350px']}
              hoverLeft={['580px', '580px', '240px', '310px', '480px']}
              hoverRight={['auto']}
              hoverBottom={['auto']}
              text="LA VALLEE VILLAGE"
              src={LaVallee}
              hover={LaValleeHover}
              onClick={goToLaValleeVillage}
            />
            <MapVillageV2
              top={['auto']}
              left={['735px', '735px', '275px', '385px', '575px']}
              right={['auto']}
              bottom={['185px', '185px', '35px', '80px', '140px']}
              hoverTop={['auto']}
              hoverLeft={['600px', '600px', '230px', '310px', '470px']}
              hoverRight={['auto']}
              hoverBottom={['70px', '70px', '0px', '15px', '40px']}
              text="LA ROCA VILLAGE"
              src={LaRoca}
              hover={LaRocaHover}
              onClick={goToLaRocaVillage}
            />
            <MapVillageV2
              top={['auto']}
              left={['390px', '390px', '130px', '195px', '295px']}
              right={['auto']}
              bottom={['120px', '120px', '5px', '50px', '85px']}
              hoverTop={['auto']}
              hoverLeft={['280px', '280px', '100px', '140px', '210px']}
              hoverRight={['auto']}
              hoverBottom={['10px', '10px', '0px', '5px', '5px']}
              text="LAS ROZAS VILLAGE"
              src={LasRozas}
              hover={LasRozasHover}
            />
            <MapVillageV2
              top={['auto']}
              left={['auto']}
              right={['645px', '645px', '260px', '255px', '465px']}
              bottom={['195px', '195px', '35px', '80px', '140px']}
              hoverTop={['auto']}
              hoverLeft={['auto']}
              hoverRight={['650px', '650px', '250px', '330px', '510px']}
              hoverBottom={['100px', '100px', '15px', '25px', '60px']}
              text="FIDENZA VILLAGE"
              src={Fidanza}
              hover={FidanzaHover}
              onClick={goToFidenzaVillage}
              mapInfoTopRight={true}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default MapV2;
